/**
 * When announcement bar is sticky, set the section header's top so it sticks below the bar.
 * Loaded only when announcement bar has "Sticky on top" enabled.
 */
(function () {
  var bar = document.querySelector('.new-announcement-bar.announcement-bar--sticky');
  if (!bar) return;

  var sectionHeader = document.querySelector('.section-header');
  if (!sectionHeader || !sectionHeader.querySelector('.new-header')) return;

  function setHeaderTop() {
    var barHeight = bar.offsetHeight;
    sectionHeader.style.setProperty('top', barHeight + 'px', 'important');
    document.documentElement.style.setProperty('--announcement-bar-height', barHeight + 'px');
  }

  setHeaderTop();

  window.addEventListener('resize', function () {
    setHeaderTop();
  });

  if (typeof ResizeObserver !== 'undefined') {
    var ro = new ResizeObserver(setHeaderTop);
    ro.observe(bar);
  }
})();
